import React from "react";
import { TurnrCard } from "~/components/card/TurnrCard.jsx";
import { ENTITY_TYPE, ROUTES } from "~/constants";
import TurnrLink from "~/components/links/TurnrLink";
import { getSelectedBrandId, getShopAddressLine } from "~/cores/appCore";
import { TurnrText } from "~/components/TurnrText.jsx";
import CountryFlag from "~/components/CountryFlag.jsx";
import EntityList from "~/components/entityAction/EntityList.js";

function ShopAddressRow(props) {
    const { entity: shopAddressData } = props;
    const address = shopAddressData?.address;
    return (
        <div>
            <div
                style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                    marginBottom: "5px",
                }}
            >
                {shopAddressData.name}
            </div>
            <div
                style={{
                    fontSize: "12px",
                    display: "flex",
                    gap: "8px",
                    alignItems: "center",
                }}
            >
                {getShopAddressLine(address)}
                {address?.countryCode && <CountryFlag width={20} countryCode={address?.countryCode} />}
            </div>
        </div>
    );
}

export default function ShopAddressPart(props) {
    const { shopAddressesServiceData, onSuccess, appProps } = props;

    return (
        <TurnrCard style={{ marginBottom: "20px" }}>
            <EntityList
                appProps={appProps}
                entityType={ENTITY_TYPE.SHOP_ADDRESS}
                entitiesServiceData={shopAddressesServiceData}
                title={"Return addresses"}
                description={
                    <div>
                        <TurnrText size={"sm"}>
                            These are the addresses that your customers will be sending their returned items.
                            <br />
                        </TurnrText>
                        <TurnrText size={"sm"}>
                            You need to setup these if you are going to use <TurnrLink href={ROUTES.INTEGRATIONS_SHIPMENT}>Shipment integrations</TurnrLink>
                        </TurnrText>
                    </div>
                }
                fetchEntitiesQueryParams={{ shopId: getSelectedBrandId(appProps) }}
                onUpdate={onSuccess}
                EntityContentComponent={ShopAddressRow}
                entityContentComponentProps={{
                    appProps,
                    onSuccess,
                }}
            />
        </TurnrCard>
    );
}
